import(/* webpackMode: "eager" */ "/var/www/webduan/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/webduan/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/FlashSaleSections.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/HeroSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/PartnerSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/ui/RevealOnScroll.tsx");
